import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import GeneralSettingsService from '../../../services/GeneralSettingsService';

const ASSISTANCE_NUMBER = '+1 587-989-4933';

const PaymentDirectivesModal = ({ show, onAcknowledge }) => {
    const [paymentSettings, setPaymentSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPaymentSettings = async () => {
            try {
                setLoading(true);
                const data = await GeneralSettingsService.getAllParameters();
                const firstParameter = data[0];

                setPaymentSettings({
                    emailInterac: firstParameter.emailInterac,
                    interacName: firstParameter.interacName,
                    securityQuestion: firstParameter.securityQuestion,
                    securityAnswer: firstParameter.securityAnswer
                });

                setError(null);
            } catch (err) {
                console.error('Erreur lors de la récupération des paramètres:', err);
                setError('Impossible de charger les directives de paiement');
            } finally {
                setLoading(false);
            }
        };

        if (show) {
            fetchPaymentSettings();
        }
    }, [show]);

    return (
        <Modal
            show={show}
            centered
            backdrop="static"
            size="lg"
            className="payment-directives-modal"
        >
            <Modal.Header className="border-bottom-0 pb-0">
                <Modal.Title className="w-100 text-center">
                    <div className="text-success fs-4 fw-bold">Transaction enregistrée!</div>
                    <div className="fs-5 mt-2">Directives de paiement</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="pt-0">
                {loading ? (
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Chargement...</span>
                        </div>
                    </div>
                ) : error ? (
                    <div className="alert alert-danger text-center">{error}</div>
                ) : paymentSettings ? (
                    <div className="payment-directives-content">
                        <div className="mb-4">
                            <p className="mb-2 mt-5">
                                <strong>Effectuez le virement Interac à l'adresse email suivante :</strong>
                            </p>
                            <p className="text-primary fs-5 fw-bold text-center mb-4">
                                {paymentSettings.emailInterac}
                            </p>

                            <p className="mb-3">
                                Notre adresse est configurée pour un dépôt automatique. Cependant, si une question et une réponse de sécurité vous sont demandées, veuillez entrer:
                            </p>

                            <div className="bg-light p-3 rounded mb-4">
                                <p className="mb-2">
                                    <strong>Nom :</strong> {paymentSettings.interacName}
                                </p>
                                <p className="mb-2">
                                    <strong>Question :</strong> {paymentSettings.securityQuestion}
                                </p>
                                <p className="mb-0">
                                    <strong>Réponse :</strong> {paymentSettings.securityAnswer}
                                </p>
                            </div>

                            <p className="text-primary text-center mb-4">
                                Besoin d'aide? Appelez nous! {ASSISTANCE_NUMBER}
                            </p>

                            <div className="alert alert-warning mb-0">
                                <p className="fw-bold mb-2">NB: Pour que la transaction soit exécutée, veuillez respecter les conditions suivantes :</p>
                                <ul className="mb-0">
                                    <li>Le numéro de compte du destinataire doit être correct</li>
                                    <li>L'email utilisé pour le virement doit correspondre à celui de votre inscription</li>
                                    <li>Le nom du compte bancaire émetteur du virement Interac doit correspondre exactement au nom associé à votre compte sur notre application</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Modal.Body>

            <Modal.Footer className="border-top-0 justify-content-center">
                <Button
                    variant="primary"
                    onClick={onAcknowledge}
                    disabled={loading}
                    className="px-5 py-2"
                >
                    {loading ? 'Chargement...' : 'J\'ai pris note'}
                </Button>
            </Modal.Footer>

            <style jsx global>{`
                .payment-directives-modal .modal-content {
                    border-radius: 15px;
                    border: none;
                    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
                }

                .payment-directives-modal .modal-header {
                    padding: 1.5rem 1.5rem 0.5rem;
                }

                .payment-directives-modal .modal-body {
                    padding: 0 1.5rem 1rem;
                }

                .payment-directives-modal .modal-footer {
                    padding: 0 1.5rem 1.5rem;
                }

                .payment-directives-content ol,
                .payment-directives-content ul {
                    padding-left: 1.2rem;
                }

                .payment-directives-content li {
                    margin-bottom: 0.5rem;
                }
            `}</style>
        </Modal>
    );
};

export default PaymentDirectivesModal;
